import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useEventTimelineSteps } from './use_event_timeline_steps';
import { WidgetContainer } from '../widget_container';
const timelineContainerCss = "tmmgh55";
const TimelineContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timelineContainerCss, props.className)} />;
});
export const TimelineWidget = ({
  event
}) => {
  const {
    steps
  } = useEventTimelineSteps(event);
  return <WidgetContainer title={I18n.t('publisher.meetings.tabs.timeline')} noPadding showBorder={false}>
      <TimelineContainer>
        {steps.map(({
        step
      }) => step)}
      </TimelineContainer>
    </WidgetContainer>;
};

require("./timeline_widget.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./timeline_widget.js");